import { render, staticRenderFns } from "./RelatorioBoletos.vue?vue&type=template&id=42539896&scoped=true&"
import script from "./RelatorioBoletos.vue?vue&type=script&lang=js&"
export * from "./RelatorioBoletos.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioBoletos.vue?vue&type=style&index=0&id=42539896&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42539896",
  null
  
)

export default component.exports